import { render, staticRenderFns } from "./baseForm.vue?vue&type=template&id=5ad64380&scoped=true&"
import script from "./baseForm.vue?vue&type=script&lang=js&"
export * from "./baseForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ad64380",
  null
  
)

export default component.exports